export default __webpack_public_path__ + "static/media/APP-min.16226187.webp";